import { render, staticRenderFns } from "./EmailActions.vue?vue&type=template&id=56538dcd&"
import script from "./EmailActions.vue?vue&type=script&lang=js&"
export * from "./EmailActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports